export var ExternalDocumentPacketClassification;
(function (ExternalDocumentPacketClassification) {
    ExternalDocumentPacketClassification["ReferralOrders"] = "REFERRAL_ORDERS";
    ExternalDocumentPacketClassification["AuthorizationStatus"] = "AUTHORIZATION_STATUS";
    ExternalDocumentPacketClassification["ProgressNotes"] = "PROGRESS_NOTES";
    ExternalDocumentPacketClassification["MedicalRecordTransferRequest"] = "MEDICAL_RECORD_TRANSFER_REQUEST";
    ExternalDocumentPacketClassification["PrescriptionRefills"] = "PRESCRIPTION_REFILLS";
    ExternalDocumentPacketClassification["DMEOrders"] = "DME_ORDERS";
    ExternalDocumentPacketClassification["ImagingReports"] = "IMAGING_REPORTS";
    ExternalDocumentPacketClassification["LabResults"] = "LAB_RESULTS";
    ExternalDocumentPacketClassification["PathologyReports"] = "PATHOLOGY_REPORTS";
    ExternalDocumentPacketClassification["DischargeSummaries"] = "DISCHARGE_SUMMARIES";
    ExternalDocumentPacketClassification["HospitalAdmissionNotes"] = "HOSPITAL_ADMISSION_NOTES";
    ExternalDocumentPacketClassification["EmergencyDepartmentNotes"] = "EMERGENCY_DEPARTMENT_NOTES";
    ExternalDocumentPacketClassification["ProcedureNotes"] = "PROCEDURE_NOTES";
    ExternalDocumentPacketClassification["Other"] = "OTHER";
    ExternalDocumentPacketClassification["Unknown"] = "UNKNOWN";
})(ExternalDocumentPacketClassification || (ExternalDocumentPacketClassification = {}));
//# sourceMappingURL=externalDocumentPacket.js.map